<template>
  <div id="app">
    <router-view />
<!--    <CheckVersion v-if="!isDev" :checkLoding.sync="checkLoding" ref="checkVersion" />-->
  </div>
</template>

<script>
import { Empty, Button } from 'vant'
import CheckVersion from '@/components/CheckVersion' // 检查版本
import { setDocumentTitle } from '@/utils/domUtil'

export default {
  components: {
    CheckVersion,
    Empty,
    VanButton: Button,
  },
  provide() {
    return {
      isDev: false,
      checkVersion: this.checkVersion, // 检查版本号
      checkLoding: this.getLoading, // 检查时的loading
    }
  },
  data() {
    return {
      checkLoding: false,
    }
  },
  watch:{
    '$route.fullPath'(){
      this.$route.meta?.title && setDocumentTitle(this.$route.meta.title)
    }
  },
  created() {
    this.isDev = process.env.NODE_ENV === 'development'
    if (window.plus) {
      console.log(111111111111)
      this.plusReady()
    } else {
      document.addEventListener('plusready', this.plusReady, false)
    }
  },
  methods: {
    plusReady() {
      // 添加中建标识到设备标识里
      let agent = plus.navigator.getUserAgent()
      if (agent.indexOf('C8DC') == -1) {
        plus.navigator.setUserAgent(agent + '/C8DC')
      }
      // 每次打开应用检查版本号
	    document.addEventListener("resume", ()=>{
        // alert("Application resume!");
        // var activeType = e.active;	// 获取激活到前台来源
        // console.log(activeType)
        this.checkVersion(true)
      }, false);
      document.addEventListener("netchange", ()=>{
        // alert("Application resume!");
        // var activeType = e.active;	// 获取激活到前台来源
        // console.log(activeType)
        this.onNetChange()
      }, false);
    },
  onNetChange(){
       let that = this;
        //获取当前网络类型
        var nt = plus.networkinfo.getCurrentType();
        switch(nt){

        case plus.networkinfo.CONNECTION_ETHERNET:

        case plus.networkinfo.CONNECTION_WIFI:
        //this.$toast('当前网络为WiFi');
        break;

        case plus.networkinfo.CONNECTION_CELL2G:

        case plus.networkinfo.CONNECTION_CELL3G:

        case plus.networkinfo.CONNECTION_CELL4G:
        //this.$toast('当前网络非WiFi');
        break;

        default:
          setTimeout(()=>{
            that.$toast('当前无网络,请检查网络');
          })
        break;

        }

        },
    getLoading() {
      return this.checkLoding
    },
    checkVersion(autoCheck) {
      this.$refs.checkVersion?.checkVersion(autoCheck)
    },
  },
}
</script>
<style>
body {
  background-color: #f7f8fa;
}
</style>
